module.exports = {
    series: require('./series'),
    movies: require('./movies'),
    trailer: require('./trailer')
};



// WEBPACK FOOTER //
// ./src/event_handlers/event_handlers.js